export default __webpack_public_path__ + "static/media/alipay.c2b070f2.svg";